export const ApiBaseUrl = Number(process.env.REACT_APP_LIVE) === 1 ? process.env.REACT_APP_BACKEND_URL_LIVE : process.env.REACT_APP_BACKEND_URL;
export const FRONTEND_URL = process.env.REACT_APP_LIVE_URL

export const API_PATH = {

    //Users
    GetAdvs: ApiBaseUrl + "users/get-advs",
    NewAdv: ApiBaseUrl + "users/adv-upload",
    GetAdvsById: ApiBaseUrl + "users/get-advs-by-id",
    GetStats: ApiBaseUrl + "users/stats",
    NewInquiry: ApiBaseUrl + "users/new-inquiry",
    SearchAdv: ApiBaseUrl + "users/search-adv",
    NewUser: ApiBaseUrl + "users/new-user",
    VerifyUserRoute: ApiBaseUrl + "users/verify-user",
    Login: ApiBaseUrl + "users/user-login",
    AdminLogin: ApiBaseUrl + "users/admin-login",
    UsersList: ApiBaseUrl + "users/get-users",
    ImageUploadRoute: ApiBaseUrl + "users/image-upload",
    GetAdvByUser: ApiBaseUrl + "users/get-adv-by-user",
    GetInquiries: ApiBaseUrl + "users/get-inquiries",
    GetLocations: ApiBaseUrl + "users/search-location",
    NewLocation: ApiBaseUrl + "users/add-new-location",
    
    //Payments
    PaymentInit: ApiBaseUrl + "payment/init-payment",
    VerifyPayment: ApiBaseUrl + "payment/verify-payment",
    GetPaymentStats: ApiBaseUrl + "payment/stats",
};

export const imp_data = {
    FounderPayment: 10000,
}